import Header from "@/components/Header";
import Footer from "@/components/Footer";

const PoliticaCookies = () => {
  return (
    <div className="min-h-screen">
      <Header />
      <main className="pt-24 pb-16">
        <div className="container mx-auto max-w-4xl">
          <h1 className="text-3xl md:text-4xl font-bold text-foreground mb-8">
            Política de Cookies
          </h1>
          
          <div className="prose prose-lg max-w-none text-muted-foreground space-y-8">
            <p className="text-sm text-muted-foreground">
              Última actualización: Enero 2026
            </p>

            <section>
              <h2 className="text-xl font-semibold text-foreground mb-4">
                1. ¿Qué son las cookies?
              </h2>
              <p>
                Las cookies son pequeños archivos de texto que los sitios web almacenan en su 
                navegador cuando los visita. Se utilizan ampliamente para hacer que los sitios 
                web funcionen de manera más eficiente y para proporcionar información a los 
                propietarios del sitio.
              </p>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-foreground mb-4">
                2. Cookies que utilizamos
              </h2>
              
              <h3 className="text-lg font-medium text-foreground mt-6 mb-3">
                2.1 Cookies estrictamente necesarias
              </h3>
              <p>
                Son esenciales para que pueda navegar por el sitio web y utilizar sus 
                funcionalidades. Sin estas cookies, servicios como el acceso a la plataforma 
                no pueden proporcionarse.
              </p>
              <div className="overflow-x-auto mt-4">
                <table className="min-w-full border border-border">
                  <thead className="bg-muted">
                    <tr>
                      <th className="px-4 py-2 text-left text-sm font-medium text-foreground">Cookie</th>
                      <th className="px-4 py-2 text-left text-sm font-medium text-foreground">Finalidad</th>
                      <th className="px-4 py-2 text-left text-sm font-medium text-foreground">Duración</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr className="border-t border-border">
                      <td className="px-4 py-2 text-sm">session_id</td>
                      <td className="px-4 py-2 text-sm">Mantener la sesión del usuario</td>
                      <td className="px-4 py-2 text-sm">Sesión</td>
                    </tr>
                    <tr className="border-t border-border">
                      <td className="px-4 py-2 text-sm">csrf_token</td>
                      <td className="px-4 py-2 text-sm">Seguridad contra ataques CSRF</td>
                      <td className="px-4 py-2 text-sm">Sesión</td>
                    </tr>
                    <tr className="border-t border-border">
                      <td className="px-4 py-2 text-sm">cookie_consent</td>
                      <td className="px-4 py-2 text-sm">Almacenar preferencias de cookies</td>
                      <td className="px-4 py-2 text-sm">12 meses</td>
                    </tr>
                  </tbody>
                </table>
              </div>

              <h3 className="text-lg font-medium text-foreground mt-6 mb-3">
                2.2 Cookies de rendimiento y análisis
              </h3>
              <p>
                Nos permiten reconocer y contar el número de visitantes y ver cómo se mueven 
                por nuestro sitio web. Esto nos ayuda a mejorar el funcionamiento del sitio.
              </p>
              <div className="overflow-x-auto mt-4">
                <table className="min-w-full border border-border">
                  <thead className="bg-muted">
                    <tr>
                      <th className="px-4 py-2 text-left text-sm font-medium text-foreground">Cookie</th>
                      <th className="px-4 py-2 text-left text-sm font-medium text-foreground">Proveedor</th>
                      <th className="px-4 py-2 text-left text-sm font-medium text-foreground">Finalidad</th>
                      <th className="px-4 py-2 text-left text-sm font-medium text-foreground">Duración</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr className="border-t border-border">
                      <td className="px-4 py-2 text-sm">_ga</td>
                      <td className="px-4 py-2 text-sm">Google Analytics</td>
                      <td className="px-4 py-2 text-sm">Distinguir usuarios</td>
                      <td className="px-4 py-2 text-sm">2 años</td>
                    </tr>
                    <tr className="border-t border-border">
                      <td className="px-4 py-2 text-sm">_gid</td>
                      <td className="px-4 py-2 text-sm">Google Analytics</td>
                      <td className="px-4 py-2 text-sm">Distinguir usuarios</td>
                      <td className="px-4 py-2 text-sm">24 horas</td>
                    </tr>
                  </tbody>
                </table>
              </div>

              <h3 className="text-lg font-medium text-foreground mt-6 mb-3">
                2.3 Cookies de funcionalidad
              </h3>
              <p>
                Permiten recordar las elecciones que hace (como su idioma o la región en la 
                que se encuentra) y proporcionan características mejoradas y más personales.
              </p>
              <div className="overflow-x-auto mt-4">
                <table className="min-w-full border border-border">
                  <thead className="bg-muted">
                    <tr>
                      <th className="px-4 py-2 text-left text-sm font-medium text-foreground">Cookie</th>
                      <th className="px-4 py-2 text-left text-sm font-medium text-foreground">Finalidad</th>
                      <th className="px-4 py-2 text-left text-sm font-medium text-foreground">Duración</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr className="border-t border-border">
                      <td className="px-4 py-2 text-sm">language</td>
                      <td className="px-4 py-2 text-sm">Recordar preferencia de idioma</td>
                      <td className="px-4 py-2 text-sm">12 meses</td>
                    </tr>
                    <tr className="border-t border-border">
                      <td className="px-4 py-2 text-sm">theme</td>
                      <td className="px-4 py-2 text-sm">Recordar preferencia de tema</td>
                      <td className="px-4 py-2 text-sm">12 meses</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-foreground mb-4">
                3. Cómo gestionar las cookies
              </h2>
              <p>
                Puede configurar su navegador para rechazar todas las cookies o para indicar 
                cuándo se envía una cookie. Sin embargo, si no acepta cookies, es posible que 
                no pueda usar algunas partes de nuestro sitio web.
              </p>
              <p className="mt-4">
                A continuación, le proporcionamos enlaces a las instrucciones de los navegadores 
                más comunes:
              </p>
              <ul className="list-disc pl-6 space-y-2 mt-4">
                <li>
                  <a href="https://support.google.com/chrome/answer/95647" target="_blank" 
                     rel="noopener noreferrer" className="text-accent hover:underline">
                    Google Chrome
                  </a>
                </li>
                <li>
                  <a href="https://support.mozilla.org/es/kb/cookies-informacion-que-los-sitios-web-guardan-en-" 
                     target="_blank" rel="noopener noreferrer" className="text-accent hover:underline">
                    Mozilla Firefox
                  </a>
                </li>
                <li>
                  <a href="https://support.apple.com/es-es/guide/safari/sfri11471/mac" target="_blank" 
                     rel="noopener noreferrer" className="text-accent hover:underline">
                    Safari
                  </a>
                </li>
                <li>
                  <a href="https://support.microsoft.com/es-es/microsoft-edge/eliminar-cookies-en-microsoft-edge" 
                     target="_blank" rel="noopener noreferrer" className="text-accent hover:underline">
                    Microsoft Edge
                  </a>
                </li>
              </ul>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-foreground mb-4">
                4. Consentimiento
              </h2>
              <p>
                De conformidad con la Ley 34/2002, de 11 de julio, de Servicios de la Sociedad 
                de la Información y de Comercio Electrónico (LSSI-CE), le informamos que este 
                sitio web utiliza cookies.
              </p>
              <p className="mt-4">
                Al acceder a nuestro sitio web por primera vez, verá un banner informándole 
                del uso de cookies. Si continúa navegando, entenderemos que acepta el uso de 
                las cookies descritas en esta política.
              </p>
              <p className="mt-4">
                Puede modificar sus preferencias de cookies en cualquier momento haciendo clic 
                en el enlace "Configuración de cookies" disponible en el pie de página.
              </p>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-foreground mb-4">
                5. Actualizaciones de esta política
              </h2>
              <p>
                Podemos actualizar esta Política de Cookies periódicamente. Le recomendamos 
                revisar esta página con regularidad para estar informado de cualquier cambio.
              </p>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-foreground mb-4">
                6. Contacto
              </h2>
              <p>
                Si tiene preguntas sobre nuestra Política de Cookies, puede contactarnos en:
              </p>
              <ul className="list-disc pl-6 space-y-2 mt-4">
                <li>Correo electrónico: <a href="mailto:soporte@habituspay.com" 
                    className="text-accent hover:underline">soporte@habituspay.com</a></li>
              </ul>
            </section>
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
};

export default PoliticaCookies;
